<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{form.main.qs_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.qs_wcname" slot="qs_wcname">
            <label class="weui-form-preview__label">{{customLabel.qs_wcname || "工作中心"}}</label>
            <em class="weui-form-preview__value">{{form.main.qs_wcname}}</em>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.qs_ngname" slot="qs_ngname">
            <label class="weui-form-preview__label">{{customLabel.qs_ngname || "不良现象"}}</label>
            <span class="weui-form-preview__value">{{form.main.qs_ngname}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.qs_remark" slot="qs_remark">
            <label class="weui-form-preview__label">{{customLabel.qs_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{form.main.qs_remark}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/qcngset",
      caller:'QcNgSet',
      xtype:'stock-qcngset-formpanel'
    };
  }
};
</script>